import React from "react";
import Title from "../Title";
import { Container } from "./styles";
import { useBreakpoint } from "gatsby-plugin-breakpoints/BreakpointProvider";
import LicenseCard from "../LicenseCard";
import CreativeCommons from "./CreativeCommons";
import BlanketLicenses from "./BlanketLicenses";
import ProjectLicenses from "./ProjectLicenses";

const licenses = [
  {
    title: "Creative Commons",
    highlightContent:
      "For personal projects and creators just getting started our mp3 files are available under a Creative Commons license Attribution-NonCommercial 4.0 International (CC BY-NC 4.0). It can be free (with attribution) for non-monetized projects that aren’t being made as part of your job.",
    fullContent: <CreativeCommons />,
    background: "#5D95AA",
    subscribe: false
  },
  {
    title: "Blanket Licenses",
    highlightContent:
      "For ongoing projects that use music (Podcasts, YouTube channels, radio shows, social media, etc.). Our subscription Blanket Licenses offer unlimited tracks for your work and access to the whole library of WAV files, multitrack stem files and variations.",
    fullContent: <BlanketLicenses />,
    background: "#9F6CB1",
    subscribe: true
  },
  {
    title: "Project Licenses",
    highlightContent:
      "For one-time projects like film, video games or performances, our project licenses offer a flexible way to license just the music you need for your project. With a sliding scale based on project budget you can access all the files have your work covered. ",
    fullContent: <ProjectLicenses />,
    background: "#AA825D",
    subscribe: false
  },
];

const LicensingPage = () => {
  const breakpoints = useBreakpoint();

  return (
    <Container className={breakpoints.md && "isMobile"}>
      <div className="page-header">
        <Title title={"Licensing"} />
        <p className="detail-text description">
          Our library is available to license for your projects in 3 different
          ways depending on your needs
        </p>
      </div>
      {licenses.map((license, index) => (
        <div className="license-card-container">
          <LicenseCard
            isMobile={breakpoints.md}
            background={license.background}
            number={index + 1}
            highlightContent={license.highlightContent}
            fullContent={license.fullContent}
            title={license.title}
            subscribe={license.subscribe}
          />
        </div>
      ))}
    </Container>
  );
};

export default LicensingPage;
